import { CompaniesList } from "../components/List/CompaniesList";
import { CompaniesCreate } from "../components/Create/CompaniesCreate";
import { CompaniesEdit } from "../components/Edit/CompaniesEdit";
import { CompaniesView } from "../components/View/CompaniesView";
import { GlobalOutlined } from "@ant-design/icons";
import { UserRole } from "@root/api.types";
export const COMPANIES_LIST = {
    path: "/admin/companies",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: CompaniesList,
    menu: {
        key: "COMPANIES_LIST",
        label: "management.companies.menu.title",
        icon: GlobalOutlined,
    },
};
export const COMPANIES_CREATE = {
    path: "/admin/companies/create",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: CompaniesCreate,
};
export const COMPANIES_EDIT = {
    path: "/admin/companies/:id/edit",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: CompaniesEdit,
};
export const COMPANIES_VIEW = {
    path: "/admin/companies/:id/view",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: CompaniesView,
};
